<template>
  <config-base ref='baseRef' show-plan-details v-bind='$props'>
    <template #config>
      <capacity-config-list
        showMonthlyPriceFromCycle
        :showSelectCapacityDropdown='false'
        :config-plan-type='planType'
        :config-capacity-key='capacityKey'
        capacityUnitI18nKey='billing.attendees'
        :configRowName='configRowName'/>
    </template>
  </config-base>
</template>

<script>
import planCommon from '@/plans/WEBINAR/mixin';
import { getPlanTotalLicense } from '@/common/service/validate';
import plansMixin from '@/plans/mx/plan';
import ConfigList from '@/components/capacity/config-list.vue';
import ConfigBase from '@/plans/WEBINAR/config/base.vue';
import { computedCapacityWebinarPlans } from '@/common/service/computers/plans/webinar';
import PlanDetailsMixin from '@/plans/EVENT_SAAS/component/dialog/plan-details/mx-plan-details';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { orderByPlanListWithCapacity } from '@/components/capacity/config-list.vue';
import {
  planTypes,
  SUBSCRIPTION_TYPE,
} from '@/common/constants';

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon, PlanDetailsMixin],
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans', 'assignInfo']),
    allCapacityOrderList() {
      return _.slice(orderByPlanListWithCapacity(this.planList, this.configCapacityKey), 0, 1);
    },
    oldPlanHost() {
      const oldPlanCode = this.$config('oldPlanCode');
      const assignInfo = this.assignInfo[oldPlanCode];
      const assignedLicense = assignInfo.assignLicenseQuantity;
      return assignedLicense || 1;
    }
  },
  methods: {
    mx_getMaxHosts() {
      const boundlePlans = this.boughtPlans.filter(p => p.type === planTypes.ZOOM_ONE_BUNDLE);
      if (boundlePlans.length) {
        const meetingPlans = this.boughtPlans.filter(p => p.type === planTypes.ZOOM_MEETING);
        const licenses = getPlanTotalLicense([...meetingPlans, ...boundlePlans]);
        return licenses;
      }
      return getPlanTotalLicense(this.getCurrentBasePlanInfo?.plans) || 999;
    },
    mx_getIncreaseTips(capacity, license) {
      const currentCapacityPlanCount = getPlanTotalLicense(computedCapacityWebinarPlans(this.selectedPlanList || [], capacity)) || license;
      return currentCapacityPlanCount >= this.mx_getMaxHosts() ? this.totalLimitDesc : '';
    },
    mx_onSelectedPlanUpdated(basePlanName) {
      this.mx_showMessage(
          this.$t('billing.license_sync_base', [this.$t('billing.webinar.title'), basePlanName]),
      );
    },
    handleLicenseChange(license) {
      if (!this.mx_canAutoAdd) return;
      this.mx_handlePlanLicenseChange(license);
    },
    mx_getOneMonthPlan() {
      // From Shani: Cancel flow should only show W100 annual and monthly, not 1 month
      return false;
    },
    mx_getDecreaseTips() {
      const currentEditPlan = this.getSelectedPlans[0];
      if (currentEditPlan.cartInfo.selected_number <= this.oldPlanHost) {
        return this.$t('billing.license_assigned_limit_toolips');
      }
      return '';
    },
    mx_getMinHosts() {
      return this.oldPlanHost;
    },
    mx_getBillingCycleGroupOptions(options) {
      return [{
        label: this.$t('billing.single_use_meeting.a_to_b_attendees', [500, 100]),
        options: options,
        type: SUBSCRIPTION_TYPE.recurring_and_one_month
      }];
    },
  },
};
export default {
  mixins: [plansMixin, planCommon],
  components: { ConfigBase, CapacityConfigList },
  computed: {
    configRowName() {
      return 'CapacityConfigRow';
    }
  }
};
</script>

<style lang='scss'>
</style>
